import { useEffect } from 'react';
import debounce from 'lodash/debounce';
export function useFooterAutoWidth(props) {
    const { footerId, containerId, hidden } = props || {};
    const setFooterWidth = () => {
        const footerDom = document.getElementById(footerId);
        const containerDom = document.getElementById(containerId);
        const formWidth = containerDom?.getBoundingClientRect?.()?.width;
        if (footerDom && typeof formWidth === 'number') {
            footerDom.style.width = `${formWidth}px`;
        }
    };
    const debounceSetFooterWidth = debounce(() => {
        setFooterWidth();
    }, 500, {
        leading: true,
    });
    useEffect(() => {
        const containerDom = document.getElementById(containerId);
        setFooterWidth();
        if (ResizeObserver && containerDom) {
            const resizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    debounceSetFooterWidth();
                }
            });
            resizeObserver.observe(containerDom);
        }
    }, [hidden]);
}
